<ng-container [formGroup]="$any(controlContainer?.control)">
    <wdx-form-field
        class="h-100"
        [locked]="formElement?.isLocked"
        [label]="label | translateTokenisedString"
        [guidanceText]="formElement?.guidanceText | translateTokenisedString"
        [isSensitive]="formElement?.isSensitive ?? undefined"
        [isRequired]="formElement?.isRequired ?? undefined"
        [labelForId]="inputId"
        [validationErrorMessage]="
            formControl?.touched
                ? (formControl?.errors | validationErrorMessage)
                : ''
        "
        [warningMessage]="warningText"
    >
        @if (documents) {
            <div>
                <div class="form-control p-0">
                    @for (
                        document of documents;
                        track $index;
                        let index = $index
                    ) {
                        <wdx-document-info
                            class="d-block w-100 border-bottom"
                            [subtitle]="$any(document.fileIndex) | fileName"
                            [label]="document?.name"
                            [fileIndex]="document.fileIndex"
                        >
                            @if (!isDisabled) {
                                <wdx-icon-button
                                    class="ms-2"
                                    size="sm"
                                    wdxStyle="outline-primary"
                                    (wdxOnClick)="onDeleteDocument(document)"
                                    ><wdx-icon icon="trash-alt"></wdx-icon
                                ></wdx-icon-button>
                                <wdx-icon-button
                                    class="ms-2"
                                    size="sm"
                                    wdxStyle="outline-primary"
                                    (wdxOnClick)="
                                        editDocument({
                                            isQuickCreate: true,
                                            preserveActiveModal: true,
                                            formId: DOCUMENT_FORM_ID,
                                            entityId: document.id,
                                        })
                                    "
                                    ><wdx-icon icon="pen"></wdx-icon
                                ></wdx-icon-button>
                            }
                        </wdx-document-info>
                    }
                    @if (!isDisabled) {
                        <div class="p-4">
                            @if (documents?.length === formElement?.max) {
                                <ng-container
                                    class="text-center body-text-medium"
                                >
                                    {{
                                        DOCUMENT_LOOKUP_MAX_DOCUMENTS
                                            | translateTokenisedString
                                                : {
                                                      max:
                                                          formElement?.max?.toString() ??
                                                          '',
                                                  }
                                    }}
                                </ng-container>
                            }
                            @if (
                                $any(documents?.length) < $any(formElement?.max)
                            ) {
                                <div class="text-center body-text-medium mb-2">
                                    {{
                                        (documents?.length
                                            ? DOCUMENT_LOOKUP_ADD_DOCUMENT_PLURAL
                                            : DOCUMENT_LOOKUP_ADD_DOCUMENT
                                        ) | translateTokenisedString
                                    }}
                                </div>
                                <div class="d-flex justify-content-center">
                                    @if (
                                        addDocumentFormSetup$ | ngrxPush;
                                        as addDocumentFormSetup
                                    ) {
                                        <wdx-icon-button
                                            class="ms-2"
                                            size="sm"
                                            data-cy="btn-add-document"
                                            wdxStyle="outline-primary"
                                            (wdxOnClick)="
                                                addDocument(
                                                    addDocumentFormSetup
                                                )
                                            "
                                            ><wdx-icon
                                                [icon]="UTILS_ICON_ADD"
                                            ></wdx-icon
                                        ></wdx-icon-button>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </wdx-form-field>
</ng-container>
